import { useMediaQuery, useTheme } from '@mui/material';

export type LineItemVariant = 'card' | 'row' | 'compact';

// card: phones (xs). row: single full-width column (sm). compact: multi-column detail (md+).
const useLineItemVariant = (): LineItemVariant => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));

  if (isXs) return 'card';
  if (isSm) return 'row';
  return 'compact';
};

export default useLineItemVariant;
